import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import AttachmentListItem from './AttachmentListItem'
import { Attachment } from '../../types/dataMatched'

interface DraggableAttachmentProps {
  attachment: Attachment
  parentId: string
}

export const DraggableAttachment: React.FC<DraggableAttachmentProps> = ({ attachment, parentId }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: attachment.fileKey,
    data: {
      type: 'attachment',
      attachment,
      parentId,
    },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? 'none' : transition,
    opacity: isDragging ? 0.3 : 1,
    zIndex: isDragging ? 1000 : 'auto',
  }

  return (
    <div ref={setNodeRef} style={style}>
      <AttachmentListItem
        dataSource={attachment}
        isDraggable={true}
        dragHandleProps={attributes}
        dragListeners={listeners}
        dragHandleRef={setActivatorNodeRef}
        isDragging={isDragging}
      />
    </div>
  )
}

interface DroppableContainerProps {
  children: React.ReactNode
  itemId: string
  className?: string
}

export const DroppableContainer: React.FC<DroppableContainerProps> = ({ 
  children, 
  itemId, 
  className 
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `container-${itemId}`,
    data: {
      type: 'container',
      itemId,
    },
  })

  return (
    <div 
      ref={setNodeRef}
      className={className}
      style={{
        backgroundColor: isOver ? 'rgba(24, 144, 255, 0.1)' : undefined,
        border: isOver ? '1px dashed var(--eui-primary-pri-500)' : undefined,
        borderRadius: '6px',
        minHeight: '36px',
        transition: 'all 0.2s ease',
      }}
    >
      {children}
    </div>
  )
}
